// @ts-nocheck
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { makeHandlerChainAwaitable } from "@insite/client-framework/HandlerCreator";
import { ShareOptions } from "@insite/client-framework/Services/WishListService";
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import removeWishListShare from "@insite/client-framework/Store/Components/ManageShareListModal/Handlers/RemoveWishListShare";
import setManageShareListModalIsOpen from "@insite/client-framework/Store/Components/ManageShareListModal/Handlers/SetManageShareListModalIsOpen";
import setShareListModalIsOpen from "@insite/client-framework/Store/Components/ShareListModal/Handlers/SetShareListModalIsOpen";
import loadWishList from "@insite/client-framework/Store/Data/WishLists/Handlers/LoadWishList";
import updateWishList from "@insite/client-framework/Store/Data/WishLists/Handlers/UpdateWishList";
import { getWishListState } from "@insite/client-framework/Store/Data/WishLists/WishListsSelectors";
import translate from "@insite/client-framework/Translate";
import TwoButtonModal, { TwoButtonModalStyles } from "@insite/content-library/Components/TwoButtonModal";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import DataTable, { DataTablePresentationProps } from "@insite/mobius/DataTable";
import DataTableBody, { DataTableBodyProps } from "@insite/mobius/DataTable/DataTableBody";
import DataTableCell, { DataTableCellProps } from "@insite/mobius/DataTable/DataTableCell";
import DataTableHead, { DataTableHeadProps } from "@insite/mobius/DataTable/DataTableHead";
import DataTableHeader, { DataTableHeaderProps } from "@insite/mobius/DataTable/DataTableHeader";
import DataTableRow from "@insite/mobius/DataTable/DataTableRow";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import Modal, { ModalPresentationProps } from "@insite/mobius/Modal";
import Radio, { RadioProps } from "@insite/mobius/Radio";
import RadioGroup, { RadioGroupProps } from "@insite/mobius/RadioGroup";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { useEffect, useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

/* Starter Custom Code - Start */
import GridContainer from "@insite/mobius/GridContainer";
import GridItem from "@insite/mobius/GridItem";
import VisuallyHidden from "@insite/mobius/VisuallyHidden";
import FormActions from "@store/Library/Components/Toolkit/FormActions";
import Heading, { HeadingPresentationProps } from "@store/Library/Components/Toolkit/Heading";
import PlusCircleFill from "@store/Library/Components/Toolkit/Icons/PlusCircle/PlusCircleFill";
import { GridContainerProps } from "@store/MobiusOverrides/GridContainer/GridContainer";
import { GridItemProps } from "@store/MobiusOverrides/GridItem/GridItem";
import { formGridProps } from "@store/Themes/common/props/form";
import { linkGetActionLinkProps } from "@store/Themes/common/props/link";
import { tableProps } from "@store/Themes/common/props/table";
import ga from "@toolkit/Framework/Common/GoogleAnalytics";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
/* Starter Custom Code - End */

interface OwnProps {
    extendedStyles?: ManageShareListModalStyles;
}

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

const mapStateToProps = (state: ApplicationState) => ({
    session: state.context.session,
    modalIsOpen: state.components.manageShareListModal.isOpen,
    wishListId: state.components.manageShareListModal.wishListId,
    wishListState: getWishListState(state, state.components.manageShareListModal.wishListId),
});

const mapDispatchToProps = {
    setManageShareListModalIsOpen,
    setShareListModalIsOpen,
    removeWishListShare,
    updateWishList: makeHandlerChainAwaitable(updateWishList),
    loadWishList,
};

export interface ManageShareListModalStyles {
    modal?: ModalPresentationProps;
    editingPermissionText?: TypographyProps;
    editingPermissionRadioGroup?: RadioGroupProps;
    editingPermissionRadio?: RadioProps;
    usersTableWrapper?: InjectableCss;
    sharedWithAllText?: TypographyProps;
    usersTableText?: TypographyProps;
    userTableHeaderText?: TypographyProps;
    inviteButton?: ButtonPresentationProps;
    userTable?: DataTablePresentationProps;
    userTableHead?: DataTableHeadProps;
    userTableHeader?: DataTableHeaderProps;
    userTableBody?: DataTableBodyProps;
    userCell?: DataTableCellProps;
    userNameText?: TypographyProps;
    userRemoveLink?: LinkPresentationProps;
    buttonsWrapper?: InjectableCss;
    makePrivateButton?: ButtonPresentationProps;
    closeButton?: ButtonPresentationProps;
    makeListPrivateModal?: TwoButtonModalStyles;
    // Starter Custom Code
    container?: GridContainerProps;
    radioGridItem?: GridItemProps;
    usersGridItem?: GridItemProps;
    usersTableHeading?: HeadingPresentationProps;
    inviteLink?: LinkPresentationProps;
    actionsHeader?: DataTableHeaderProps;
    actionsCell?: DataTableCellProps;
    userRemoveButton?: ButtonPresentationProps;
}

export const addToListModalStyles: ManageShareListModalStyles = {
    /* Foundation Custom Code - Start */
    modal: {
        sizeVariant: "medium",
        cssOverrides: {
            modalTitle: css`
                padding: 10px 20px;
            `,
            modalContent: css`
                padding: 20px;
            `,
        },
    },
    editingPermissionText: {
        weight: "bold",
    },
    /* Foundation Custom Code - End */

    sharedWithAllText: {
        css: css`
            margin-top: 15px; /* Foundation */
            display: block;
            margin-bottom: ${pxToRem(20)};
        `,
    },
    container: formGridProps.gridContainer,
    radioGridItem: { width: 12 },
    editingPermissionRadioGroup: { horizontal: true },
    usersGridItem: {
        width: 12,
        css: css`
            flex-direction: column;
        `,
    },
    usersTableHeading: {
        forwardAs: "p",
        verticalAlign: "middle",
        extendedStyles: {
            title: {
                css: css`
                    display: block;
                    width: 100%;
                    margin-bottom: ${pxToRem(8)};
                    font-weight: ${x => x.theme.design.typography.weight.bold};
                `,
            },
        },
    },
    inviteLink: linkGetActionLinkProps(PlusCircleFill),
    actionsHeader: tableProps.tightHeader,
    actionsCell: tableProps.narrowCell,
    userRemoveButton: tableProps.button,
    makePrivateButton: { variant: "secondary" },
};

const ManageShareListModal = ({
    modalIsOpen,
    wishListId,
    wishListState,
    extendedStyles,
    setManageShareListModalIsOpen,
    setShareListModalIsOpen,
    removeWishListShare,
    updateWishList,
    loadWishList,
}: Props) => {
    const [styles] = useState(() => mergeToNew(addToListModalStyles, extendedStyles));

    const [wishList, setWishList] = useState(wishListState.value);

    /* Starter Custom Code - Start */
    const trackMakeWishListPrivate = ga.use.trackMakeWishListPrivate({}, { wishList });
    const trackRemoveUserFromWishList = ga.use.trackRemoveUserFromWishList({}, { wishList });
    /* Starter Custom Code - End */

    const [allowEditing, setAllowEditing] = useState(wishList?.allowEdit.toString());
    useEffect(() => {
        if (!wishListState.value || typeof wishListState.value.sharedUsers === "undefined") {
            return;
        }

        setWishList(wishListState.value);
        setAllowEditing(wishListState.value.allowEdit.toString());
    }, [wishListState]);

    const [makeListPrivateModalVisible, setMakeListPrivateModalVisible] = useState(false);

    useEffect(() => {
        if (!modalIsOpen || !wishListId || wishListState.isLoading) {
            return;
        }

        if (wishListState.value?.sharedUsers !== null) {
            return;
        }

        loadWishList({
            wishListId,
            exclude: ["listLines"],
            expand: ["sharedUsers", "favorite", "hidden", "tags"],
        });
    }, [modalIsOpen, wishListState]);

    const modalCloseHandler = () => {
        setManageShareListModalIsOpen({ modalIsOpen: false });
    };

    const inviteClickHandler = () => {
        setShareListModalIsOpen({ modalIsOpen: true, wishListId, fromManage: true });
        setManageShareListModalIsOpen({ modalIsOpen: false });
    };

    const userRemoveHandler = (userId: string) => {
        if (!wishList) {
            return;
        }

        const isLastUser = wishList.sharedUsers?.length === 1;
        removeWishListShare({ wishList, userId });
        trackRemoveUserFromWishList(); // Starter Custom Code
        if (isLastUser) {
            trackMakeWishListPrivate(); // Starter Custom Code
            setManageShareListModalIsOpen({ modalIsOpen: false });
        }
    };

    const handleMakeListPrivateClick = async () => {
        if (!wishList) {
            return;
        }

        await updateWishList({
            apiParameter: {
                wishList: {
                    ...wishList,
                    sendEmail: false,
                    shareOption: ShareOptions.Private,
                },
            },
        });
        setMakeListPrivateModalVisible(false);
        setManageShareListModalIsOpen({ modalIsOpen: false });
        trackMakeWishListPrivate(); // Starter Custom Code
    };

    const handleOpenMakeListPrivateClick = () => {
        setMakeListPrivateModalVisible(true);
    };

    const handleEditingPermissionChanged = async (event: React.ChangeEvent<HTMLInputElement>) => {
        if (!wishList) {
            return;
        }

        setAllowEditing(event.target.value);
        await updateWishList({
            apiParameter: {
                wishList: {
                    ...wishList,
                    sendEmail: false,
                    allowEdit: event.target.value === "true",
                },
            },
            skipWishListsReset: true,
        });
    };

    return (
        <Modal
            {...styles.modal}
            headline={translate("Manage Sharing")}
            isOpen={modalIsOpen}
            handleClose={modalCloseHandler}
        >
            {/* Starter Removed - editingPermissionText */}
            {/* Starter Custom Code - Start */}
            {wishList?.shareOption === ShareOptions.AllCustomerUsers && (
                <Typography {...styles.sharedWithAllText}>
                    {translate("Shared with all users on billing account.")}
                </Typography>
            )}
            {/* Starter Custom Code - End */}
            <GridContainer {...styles.container} /* Starter Custom Code */>
                <GridItem {...styles.radioGridItem} /* Starter Custom Code */>
                    <RadioGroup
                        label={translate("Editing Permission") /* Starter Custom Code */}
                        value={allowEditing}
                        onChangeHandler={event => {
                            handleEditingPermissionChanged(event);
                        }}
                        {...styles.editingPermissionRadioGroup}
                    >
                        <Radio
                            value="true"
                            {...styles.editingPermissionRadio}
                            disabled={wishListState.isLoading}
                            data-test-selector="radio_allowEdit"
                        >
                            {translate("Allow Editing")}
                        </Radio>
                        <Radio
                            value="false"
                            {...styles.editingPermissionRadio}
                            disabled={wishListState.isLoading}
                            data-test-selector="radio_ViewOnly"
                        >
                            {translate("View Only")}
                        </Radio>
                    </RadioGroup>
                </GridItem>
                {/* Starter Moved - sharedWithAllText - up */}
                {wishList && wishList.shareOption !== ShareOptions.AllCustomerUsers && (
                    <GridItem {...styles.usersGridItem} /* Starter Custom Code */>
                        {/* Starter Custom Code - Start */}
                        <Heading title={translate("Users Shared With")} {...styles.usersTableHeading}>
                            <Link
                                {...styles.inviteLink}
                                disabled={wishListState.isLoading}
                                onClick={inviteClickHandler}
                                data-test-selector="inviteUser"
                            >
                                {translate("Invite User")}
                            </Link>
                        </Heading>
                        {/* Starter Custom Code - End */}
                        <DataTable {...styles.userTable}>
                            <DataTableHead {...styles.userTableHead}>
                                <DataTableHeader {...styles.userTableHeader} title={translate("User")}>
                                    <Typography {...styles.userTableHeaderText}>{translate("User")}</Typography>
                                </DataTableHeader>
                                <DataTableHeader {...styles.actionsHeader /* Starter Custom Code */}>
                                    <VisuallyHidden>{translate("Actions")}</VisuallyHidden>
                                </DataTableHeader>
                            </DataTableHead>
                            <DataTableBody {...styles.userTableBody} data-test-selector="manageShareList_TableDatas">
                                {wishList.sharedUsers?.map(({ id, displayName }) => (
                                    <DataTableRow key={id}>
                                        <DataTableCell {...styles.userCell}>
                                            <Typography {...styles.userNameText} data-test-selector="userName_Text">
                                                {displayName || id}
                                            </Typography>
                                        </DataTableCell>
                                        <DataTableCell {...styles.actionsCell} /* Starter Custom Code */>
                                            <Button /* Starter Custom Code */
                                                {...styles.userRemoveButton}
                                                disabled={wishListState.isLoading}
                                                onClick={() => userRemoveHandler(id)}
                                                data-test-selector={`removeUser_${displayName || id}`}
                                            >
                                                {translate("Remove")}
                                            </Button>
                                        </DataTableCell>
                                    </DataTableRow>
                                ))}
                            </DataTableBody>
                        </DataTable>
                    </GridItem>
                )}
                {/* Starter Removed - buttonsWrapper */}
            </GridContainer>
            {/* Starter Custom Code - Start */}
            <FormActions>
                <Button
                    {...styles.closeButton}
                    disabled={wishListState.isLoading}
                    onClick={() => modalCloseHandler()}
                    data-test-selector="doneButton"
                >
                    {translate("Done")}
                </Button>
                <Button
                    {...styles.makePrivateButton}
                    disabled={wishListState.isLoading}
                    onClick={handleOpenMakeListPrivateClick}
                    data-test-selector="makeListPrivate"
                >
                    {translate("Make List Private")}
                </Button>
            </FormActions>
            {/* Starter Custom Code - End */}
            <TwoButtonModal
                {...styles.makeListPrivateModal}
                headlineText={translate("Make List Private")}
                messageText={siteMessage("Lists_Shared_Users_Will_No_Longer_Have_Access")}
                cancelButtonText={translate("Cancel")}
                submitButtonText={translate("Make List Private")}
                submitTestSelector="makeListPrivate_Button"
                modalIsOpen={makeListPrivateModalVisible}
                onCancel={() => setMakeListPrivateModalVisible(false)}
                onSubmit={handleMakeListPrivateClick}
            />
        </Modal>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(ManageShareListModal);
